import React from "react";

interface AppliedPromoProps {
  promoCode: string;
}

export default function AppliedPromo({
  promoCode,
}: Readonly<AppliedPromoProps>) {
  return (
    <div
      className="inline-flex items-center justify-center py-spacing-xxs px-spacing-xs rounded-full"
      style={{ background: "var(--Surface-feedback-success, #E8F7E9)" }}
    >
      <span
        className="font-medium text-[12px] leading-[12px]"
        style={{
          fontFamily: "faktum",
          color: "var(--Text-feedback-success, #008205)",
        }}
      >
        {promoCode} applied
      </span>
    </div>
  );
}
